/* Reviews showcase auto-rotation — sections/reviews-showcase.liquid, setting « Auto-rotate reviews ».
   Advances the row by one card every data-interval ms and goes back to the first card after the last.
   Stops while the pointer is over the row or focus is inside it, while a visitor swipes, while the row is off
   screen or the tab hidden, and never runs for visitors who ask for reduced motion. */
if (!customElements.get('reviews-carousel')) {
  customElements.define('reviews-carousel', class ReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.reviews-showcase__list');
      if (!this.list) return;
      this.interval = Math.max(parseInt(this.dataset.interval, 10) || 5000, 2000);
      this.timer = null;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.refresh = this.refresh.bind(this);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.refresh(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.refresh(); });
      this.addEventListener('focusin', () => { this.focused = true; this.refresh(); });
      this.addEventListener('focusout', (event) => {
        if (this.contains(event.relatedTarget)) return;
        this.focused = false;
        this.refresh();
      });
      // A swipe or a drag restarts the count, so the row never moves right under the visitor's finger.
      this.list.addEventListener('pointerdown', () => this.restart(), { passive: true });
      this.list.addEventListener('touchstart', () => this.restart(), { passive: true });
      document.addEventListener('visibilitychange', this.refresh);
      if (this.reducedMotion.addEventListener) this.reducedMotion.addEventListener('change', this.refresh);

      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.refresh();
      }, { threshold: 0.3 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('visibilitychange', this.refresh);
      if (this.reducedMotion && this.reducedMotion.removeEventListener) this.reducedMotion.removeEventListener('change', this.refresh);
    }

    canRun() {
      return this.visible && !this.hovered && !this.focused && !document.hidden && !this.reducedMotion.matches
        && this.list.scrollWidth - this.list.clientWidth > 2;
    }

    refresh() {
      if (this.canRun()) {
        if (!this.timer) this.timer = setInterval(() => this.next(), this.interval);
      } else {
        this.stop();
      }
    }

    restart() {
      this.stop();
      this.refresh();
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const items = this.list.children;
      if (items.length < 2) return;
      const step = items[1].offsetLeft - items[0].offsetLeft;
      const maxScroll = this.list.scrollWidth - this.list.clientWidth;
      const rtl = getComputedStyle(this.list).direction === 'rtl';
      const position = Math.abs(this.list.scrollLeft);
      const left = position >= maxScroll - 2 ? 0 : Math.min(position + Math.abs(step), maxScroll);
      this.list.scrollTo({ left: rtl ? -left : left, behavior: 'smooth' });
    }
  });
}
